import { Entity } from "@rest-hooks/endpoint";
export class ApplicationMortgageERegistrationEntity extends Entity {
    constructor() {
        super();
        this.applicationId = 0;
        this.applicationMortgageERegistrationId = 0;
        this.documentYear = 0;
        this.documentNumber = 0;
        this.documentOffice = "";
        this.message = "";
        this.status = "";
        this.registrationDate = "";
        this.registrationTime = "";
        this.mortgageValue = 0;
        this.expirationDate = "";
    }
    pk(parent, key) {
        return this.applicationMortgageERegistrationId?.toString() ?? "";
    }
}
//# sourceMappingURL=ApplicationMortgageERegistrationEntity.js.map